(function () {
  var lm_pe_force_show_local = 0;
  var lm_pe_thumbnail = document.querySelector('#SpallaPlayer #proximo-thumb');
  var lm_pe_botao = document.querySelector('#SpallaPlayer #proximo-botao');

  var progressBar = new ProgressBar.Circle('#proximo-botao', {
    color: '#FFFFFF',
    strokeWidth: 8,
    easing: 'linear',
    svgStyle: {
      display: 'block',
      width: '100%',
      zIndex: 5
    }
  });

  function criaContador() {
    progressBar.animate(
      1,
      {
        duration: 5 * 1000
      },
      function () {
        navegaProximoEvento();
      }
    );
  }

  function navegaProximoEvento() {
    var video = window.Spalla.pegaProximoVideoDaPlaylist();
    if (window.Spalla.player != undefined) {
      window.Spalla.player.poster = spalla_assets_url_base + video.thumbnail;
    }
    novoVideoSpalla(video.video_id);
    escondeElemento('proximo');
    progressBar.stop();
    progressBar.set(1);
  }

  function initProximoVideo() {
    if (!window.Spalla.config) return;
    if (!window.Spalla.config.playlist) return;

    var video = window.Spalla.pegaProximoVideoDaPlaylist();

    lm_pe_botao.removeEventListener('click', navegaProximoEvento);
    if (video === null) {
      return;
    }

    lm_pe_botao.addEventListener('click', navegaProximoEvento);
    lm_pe_thumbnail.src = spalla_assets_url_base + video.thumbnail;
    mostraElemento('proximo');
    criaContador();
  }

  setInterval(function () {
    if (lm_live_pe === null) {
      return;
    }
    if (lm_pe_force_show_local === 0 && server_time > 0) {
      lm_pe_force_show_local = server_time;
    }
    if (lm_live_pe_show > lm_pe_force_show_local) {
      lm_pe_force_show_local = lm_live_pe_show;
      initProximoVideo();
    }
  }, 1000);

  window.initProximoVideo = initProximoVideo;
})();